import { Loader, Message } from "semantic-ui-react";

import { useTranslation } from "react-i18next";

import Flex from "../../../../components/Flex/Flex";

import LoadingContext from "../LoadingContext/LoadingContext";
import Table from "../Table/Table";

export default function DataTable({
	data,
	loading,
	error,
	columns,
	searchQuery,
	searchableKeys,
	onClick,
	noDataAvailableMessage,
	visibleColumns,
	allowEmpty,
	nbHits,
	nbPages,
	setPage,
	setSearchQuery,
	...props
}) {
	const { t } = useTranslation();

	const filteredData =
		searchableKeys && searchQuery
			? data?.filter((row) =>
					searchableKeys.some((key) => row[key]?.toLowerCase().includes(searchQuery?.toLowerCase())),
			  )
			: data;

	return (
		<LoadingContext
			noDataAvailableMessage={noDataAvailableMessage}
			data={!allowEmpty ? filteredData : undefined}
			loading={loading}
			loader={
				<Message>
					<Flex justifyContent="flex-start" gap={10}>
						<Loader active size="tiny" inline />
						<span>{t("loading", "Loading")}</span>
					</Flex>
				</Message>
			}
			error={error}
		>
			<Table
				data={filteredData}
				footer={false}
				columns={columns}
				onClickRow={onClick && ((e, { original }) => onClick(original))}
				hiddenColumns={
					visibleColumns ? columns.map(({ id }) => id).filter((id) => !visibleColumns.includes(id)) : []
				}
				{...props}
			/>
		</LoadingContext>
	);
}
